import * as React from 'react';
import { DefaultLogo } from './variants/DefaultLogo';
import { BusinessLogo } from './variants/BusinessLogo';
import { applyPrefix, getSemanticValue } from '../../utils/cssVariables';
const monochromeCss = {
    [applyPrefix('logo-free', 's')]: getSemanticValue('logo-subtitle'),
    [applyPrefix('logo-now', 's')]: getSemanticValue('logo-subtitle')
};
const Logo = ({ monochrome, variant }) => {
    const Component = variant === 'business' ? BusinessLogo : DefaultLogo;
    return React.createElement(Component, { style: monochrome ? monochromeCss : undefined });
};
export { Logo };
